<template>
  <v-container>
    <v-card>
      
      <div>Input Orders</div>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4">
            <v-radio-group v-model="timeRange" class="text-center">
              <!-- Add justify-space-around to give space between columns -->
              <v-row class="justify-space-around">
                <v-col cols="5">
                  <v-radio label="This Week" value="this week"></v-radio>
                </v-col>
                <v-col cols="5">
                  <v-radio label="This Month" value="this month"></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-select
              v-model="selectedDepot"
              :items="depots"
              item-text="name"
              item-value="id"
              label="Select a depot"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
      
      <v-row v-for="(value, key) in orderAmountGrouping" :key="key" class="text-center" >
        <v-col class="text-left ml-4">{{$t(key).replace(/_/g, " ")}}</v-col>
        <v-col class="text-center text-no-wrap" style="display: inline-block;"> <Currency :value="typeof(value) == 'object' ? (value || {})[selectedDepot || 'all_orders'] : value " /></v-col>
      </v-row>
    </v-card>

    <v-card class="mt-6 pt-3">
      <div>
        <div class="display-1">Quantity of Items Ordered</div>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="status"
              :items="statuses"
              label="Select a status"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="text-center">
          <v-col class="text-left ml-4 headline">Order</v-col>
          <v-col class="headline"> Quantity</v-col>
          <v-col class="headline"> Amount </v-col>
        </v-row>
        <v-row v-for="(value, key) in quantityOfOrderedItem" :key="key" class="text-center" >
          <v-col class="text-left ml-4">{{ key.replace(/_/g, " ").charAt(0).toUpperCase() + key.slice(1)}}</v-col>
          <v-col>{{value.quantity}}</v-col>
          <v-col><Currency :value="value.value" /></v-col>
        </v-row>
      </div>
    </v-card>
  </v-container>
</template>

<script>
  import lookups from "@/mixins/lookups";
  import Currency from '@/components/Currency';



  export default {
    components: { Currency },

    data() {
      return {
        inputOrderDetails: {},
        timeRange: undefined,
        selectedDepot: undefined,
        status: undefined,
      }
    },
    computed: {
      orderAmountGrouping() {
        if (this.selectedDepot) {
          return (((this.inputOrderDetails || {}).order_amount_per_depot || {})[this.selectedDepot] || {}).statuses || {}
        } else if (this.inputOrderDetails) {
          return ((this.inputOrderDetails || {}).all_order_amounts || {}) || {}
        }
      },

      depots() {
        const depotsAmountGrouping = Object.keys((this.inputOrderDetails || {}).order_amount_per_depot || {})
        const depots = depotsAmountGrouping.map( depotId => {
          const depot = ((this.inputOrderDetails || {}).order_amount_per_depot || {})[depotId] || {}
          return { id: depotId, name: depot.name || depotId }
        })
        return depots
      },

      statuses() {
        return ["delivered", "confirmed", "placed"]
      },

      quantityOfOrderedItem() {
        if (this.selectedDepot) {
          if (this.status) {
            return ((((this.inputOrderDetails || {}).order_depot_status_grouping || {})[this.selectedDepot] || {}).statuses || {})[this.status] || {}
          } else {
            return (((this.inputOrderDetails || {}).quantity_of_item_ordered_per_depot || {})[this.selectedDepot] || {}).items || {}
          }
        } else if (this.status) {
          return ((this.inputOrderDetails || {}).order_status_grouping || {})[this.status] || {}
        } else {
          return (this.inputOrderDetails || {}).items_summary || {}
        }
        
      }
    },

    watch: {
      timeRange(to) {
        this.remoteLookup('inputs_ordered', {timeRange: to}).then( orders => {console.log(orders); this.inputOrderDetails = orders} ).catch(e => this.inputOrderDetails = null);
      }
      
    },

    mounted() {
      this.remoteLookup('inputs_ordered', {}).then( orders => { this.inputOrderDetails = orders} ).catch(e => this.inputOrderDetails = null);
    },
    mixins: [lookups],
  }
</script>

<style scoped>
.custom-card {
  max-width: 400px;
  min-height: 250px;
}
</style>

<i18n>
  {
    "en": {
      "amount_of_all_orders": "Total value of Orders Placed",
      "amount_of_paid_for_orders": "Total cash receipts",
      "amount_of_unpaid_for_orders": "Total value of open orders",
      "delivered": "Total value of Orders Delivered",
      "confirmed": "Total value of Orders Confirmed",
      "placed": "Total value of Orders Placed"
    }
  }
  </i18n>
